<div class="row justify-content-center luvema-lp-wrapper">
  <div>
    <div class="col-xl-12">
      <p>Helaas is het op dit moment niet meer mogelijk om Luvema dorpels te bestellen via het online portaal. U kunt
        deze nog wel bestellen middels onderstaande formulieren.</p>
      <h6>Bestelformulieren aluminium onderdorpels:</h6>
      <ul>
        <li><a href="https://luvema.nl/wp-content/uploads/2024/06/Bestelformulier-Lu-BI.pdf"
            target="_blank">Binnensponning BI.5757 / BI.6351</a></li>
        <li><a href="https://luvema.nl/wp-content/uploads/2024/06/Bestelformulier-Lu-BU.pdf"
            target="_blank">Buitensponning BU.4272 / BU.4767</a>
        </li>
        <li><a href="https://luvema.nl/wp-content/uploads/2024/06/Bestelformulier-Lu-HS-schema-A.pdf"
            target="_blank">Hefschuif schema A – HS.140 / HS.146</a></li>
        <li><a href="https://luvema.nl/wp-content/uploads/2024/06/Bestelformulier-Lu-HS-schema-C-en-G.pdf"
            target="_blank">Hefschuif schema C & G – HS.140 / HS.146</a></li>
        <li><a href="https://luvema.nl/wp-content/uploads/2024/06/Bestelformulier-Lu-HS-schema-D.pdf"
            target="_blank">Hefschuif schema D – HS.140 / HS.146</a></li>
        <li><a href="https://luvema.nl/wp-content/uploads/2024/06/Bestelformulier-Lu-HS-special.pdf"
            target="_blank">Hefschuif specials – HS.140 /HS.146</a></li>
      </ul>
      <div>
        <div>Telefoon: +31(0)317-612878</div>
        <div>Email: <a href="mailto:info@luvema.nl">info@luvema.nl</a></div>
      </div>
    </div>
  </div>
</div>